import {
    SEND_MAIL,
    LIST_RATERS,

    RATERS_SUCCESS,
    RATERS_ERROR,
  
  } from "./actionTypes"
  const initialState = {
    successMsg: null,
    error: null,
  }
  
  const RatersInvite = (state = initialState, action) => {
    switch (action.type) {

      case RATERS_SUCCESS:
        state = {
          ...state,
          loading: false,
          successMsg: action.payload,
        }
        break
      case RATERS_ERROR:
        state = { ...state, error: action.payload, loading: false, }
        break
  
      // edit RATERS
      case SEND_MAIL:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // list RATERS
      case LIST_RATERS:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default RatersInvite
  